import React from "react";
import SecondaryButton from "../../ui-library/Buttons/SecondaryButton/SecondaryButton";
import PrimaryButton from "../../ui-library/Buttons/PrimaryButton/PrimaryButton";
import styled, { css, withTheme } from "styled-components";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import AlertUGNX from "../../ToastsAndAlerts/AlertUGNX";
import { AlertType } from "../../ToastsAndAlerts/constants";

const ActionButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  ${(props) =>
    !props.removeMarginBottom &&
    css`
      margin-top: 38px;
    `};
  @media (max-width: 576px) {
    button {
      width: 100%;
    }
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: 576px) {
    height: 100%;
  }
`;

const WarningMessageWrapper = styled.div`
  margin-top: 30px;

  @media (max-width: 576px) {
    margin-top: auto;
  }
`;

const ConfirmRequest = (props) => {
  const { message, warningMessage, onConfirm, onClose, submitting } = props;

  const { t } = useTranslation();

  return (
    <Container data-testid="confirm-request">
      <span dangerouslySetInnerHTML={{ __html: message }} />

      {warningMessage && (
        <WarningMessageWrapper>
          <AlertUGNX type={AlertType.WARNING}>{warningMessage}</AlertUGNX>
        </WarningMessageWrapper>
      )}
      <ActionButtonsContainer removeMarginBottom={!!warningMessage}>
        <SecondaryButton
          data-testid="cancel-button"
          className="me-2"
          onClick={onClose}
        >
          {t("appText.confirmRequest.cancel")}
        </SecondaryButton>
        <PrimaryButton
          data-testid="confirm-button"
          onClick={onConfirm}
          disabled={submitting}
        >
          {t("appText.confirmRequest.confirm")}
        </PrimaryButton>
      </ActionButtonsContainer>
    </Container>
  );
};

ConfirmRequest.propTypes = {
  message: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default withTheme(ConfirmRequest);
